<script setup>
import {ref, computed} from "vue";
import StartupModal from "@/views/needs/need/startupModal/StartupModal.vue";

const props = defineProps(['activities']);

const startupModal = ref(null);
const page = ref(1);

const displayedActivities = computed(() => props.activities.slice(0, page.value * 5));
const hasMore = computed(() => props.activities.length > displayedActivities.value.length);

function showStartupDetails(linkId) {
    startupModal.value.open(linkId)
}
</script>

<template>
    <div class="card-headline__content">
        <ul class="need-list-activity">
            <li
                v-for="activity in displayedActivities"
                :key="activity.link_id"
                :class="{'need-list-activity__like': activity.status === 'Liked'}"
            >
                <span>{{activity.status}} <a @click="showStartupDetails(activity.link_id)" class="link">{{ activity.name }}</a></span>
            </li>
        </ul>

        <div v-if="hasMore" class="text-center">
            <a @click="page++" class="link">Load More</a>
        </div>

        <StartupModal ref="startupModal"/>
    </div>
</template>

<style scoped>

</style>
